import { failed, fulfilled } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { CLOSE_SNACKBAR, OPEN_SNACKBAR_WITH_ERR, OPEN_SNACKBAR_WITH_SUCCESS } from "actions/snackBar";
import { ActionType } from "redux-promise-middleware";
import { GET_SUBJECTS, CREATE_SUBJECT, UPDATE_SUBJECT } from "actions/subjects";
import { GET_TEMPLATES } from "actions/templates";
import { GET_ALIGNMENT_RESULTS } from "actions/alignmentResults";
import { ADD_RULE } from "actions/rules";
import { UPDATE_CONFIG } from "actions/config";

const err = (message: string, autoHideDuration = 10000) => ({
  type: "error",
  message,
  autoHideDuration,
});

const success = (message: string, autoHideDuration = 10000) => ({
  type: "success",
  message,
  autoHideDuration,
});

const snackBarState = (state = initialState.snackBarState || null, action: any = {}) => {
  switch (action.type) {
    case CLOSE_SNACKBAR:
      return null;
    case OPEN_SNACKBAR_WITH_ERR:
      return err(action.payload.message);
    case OPEN_SNACKBAR_WITH_SUCCESS:
      return success(action.payload.message);
    case failed(GET_SUBJECTS):
      return err("Unable to load subjects.");
    case failed(GET_TEMPLATES):
      return err("Unable to load templates.");
    case failed(GET_ALIGNMENT_RESULTS):
      return err("Unable to load alignment tool results.");
    case failed(CREATE_SUBJECT):
      return err("Unable to create new site.");
    case failed(UPDATE_SUBJECT):
      return err("Unable to update site.");
    case failed(ADD_RULE):
      return err("Unable to upload rules version.");
    case fulfilled(ADD_RULE):
      return action.payload.errors ? null : success("Rules uploaded successfully.");
    case failed(UPDATE_CONFIG):
      return err("Unable to update application settings.");
    case fulfilled(UPDATE_CONFIG):
      return success("Application settings updated successfully.");
    default:
      // Handle unknown errors
      if (action.type && (action.type as string).endsWith(ActionType.Rejected)) {
        return err("An unknown error has occurred");
      } else {
        return state;
      }
  }
};

export default snackBarState;
